import {
  GET_CATEGORIES_REQUESTED,
  GET_CATEGORIES_SUCCEEDED,
  GET_CATEGORIES_FAILED,
  UPDATE_CATEGORIES_REQUESTED,
  UPDATE_CATEGORIES_SUCCEEDED,
  UPDATE_CATEGORIES_FAILED,
  CREATE_CATEGORY_REQUESTED,
  CREATE_CATEGORY_SUCCEEDED,
  CREATE_CATEGORY_FAILED,
  SET_CATEGORIES_INDEXES,
  SET_MODIFIER_GROUPS_INDEXES,
  UPDATE_REPORTING_CATEGORY_REQUESTED,
  UPDATE_REPORTING_CATEGORY_SUCCEEDED,
  UPDATE_REPORTING_CATEGORY_FAILED,
  CREATE_REPORTING_CATEGORY_REQUESTED,
  CREATE_REPORTING_CATEGORY_SUCCEEDED,
  CREATE_REPORTING_CATEGORY_FAILED,
  SEARCH_MODIFIER_GROUP_SUCCEEDED,
  SELECT_ITEMS_ASSIGNED_TO_DISPLAY_CATEGORY,
  SET_CATEGORIES_SORTING_MODE,
  SET_MODIFIER_GROUPS_SORTING_MODE,
} from './constants'
import api from 'utils/api'

export const selectItemsAssignedToDisplayCategory = (payload) => ({
  type: SELECT_ITEMS_ASSIGNED_TO_DISPLAY_CATEGORY,
  payload,
})

export const searchModifierGroup = (payload) => ({
  type: SEARCH_MODIFIER_GROUP_SUCCEEDED,
  payload,
})

//get
export const getCategoriesRequested = () => ({
  type: GET_CATEGORIES_REQUESTED,
})

export const getCategoriesSucceeded = (payload) => ({
  type: GET_CATEGORIES_SUCCEEDED,
  payload,
})

export const getCategoriesFailed = () => ({
  type: GET_CATEGORIES_FAILED,
})

export const loadCategories = (venueUuid) => (dispatch) => {
  dispatch(getCategoriesRequested())

  return api
    .fetchCategories(venueUuid)
    .then((response) =>
      dispatch(getCategoriesSucceeded(response.data.itemCategories))
    )
    .catch(() => dispatch(getCategoriesFailed()))
}

export const createCategoryRequested = () => ({
  type: CREATE_CATEGORY_REQUESTED,
})

export const createCategorySucceeded = (payload) => ({
  type: CREATE_CATEGORY_SUCCEEDED,
  payload,
})

export const createCategoryFailed = () => ({
  type: CREATE_CATEGORY_FAILED,
})

export const createCategory = (data) => (dispatch) => {
  dispatch(createCategoryRequested())

  const params = { itemCategories: data }

  return api
    .createCategory(params)
    .then((response) =>
      dispatch(createCategorySucceeded(response.data.itemCategories))
    )
    .catch(() => dispatch(createCategoryFailed()))
}

export const updateCategoriesRequested = () => ({
  type: UPDATE_CATEGORIES_REQUESTED,
})

export const updateCategoriesSucceeded = (payload) => ({
  type: UPDATE_CATEGORIES_SUCCEEDED,
  payload,
})

export const updateCategoriesFailed = () => ({
  type: UPDATE_CATEGORIES_FAILED,
})

export const updateCategories = (data) => (dispatch) => {
  dispatch(updateCategoriesRequested())

  const params = { itemCategories: data }

  return api
    .updateCategory(params)
    .then((response) =>
      dispatch(
        updateCategoriesSucceeded(response.data.itemCategories)
      )
    )
    .catch(() => dispatch(updateCategoriesFailed()))
}

export const setCategoriesIndexes = (payload) => ({
  type: SET_CATEGORIES_INDEXES,
  payload,
})

export const setModifierGroupsIndexes = (payload) => ({
  type: SET_MODIFIER_GROUPS_INDEXES,
  payload,
})

//update
export const updateReportingCategoryRequested = () => ({
  type: UPDATE_REPORTING_CATEGORY_REQUESTED,
})
export const updateReportingCategorySucceeded = (payload) => ({
  type: UPDATE_REPORTING_CATEGORY_SUCCEEDED,
  payload,
})
export const updateReportingCategoryFailed = () => ({
  type: UPDATE_REPORTING_CATEGORY_FAILED,
})

export const updateReportingCategories = (data) => (dispatch) => {
  dispatch(updateReportingCategoryRequested())
  const params = { itemCategories: data }
  return api
    .updateReportingCategory(params)
    .then((res) =>
      dispatch(
        updateReportingCategorySucceeded(res.data.itemCategories)
      )
    )
    .catch(() => dispatch(updateReportingCategoryFailed()))
}

// create new

export const createReportingCategoryRequested = () => ({
  type: CREATE_REPORTING_CATEGORY_REQUESTED,
})
export const createReportingCategorySucceeded = (payload) => ({
  type: CREATE_REPORTING_CATEGORY_SUCCEEDED,
  payload,
})
export const createReportingCategoryFailed = () => ({
  type: CREATE_REPORTING_CATEGORY_FAILED,
})

export const createReportingCategory = (data) => (dispatch) => {
  dispatch(createReportingCategoryRequested())

  const params = { itemCategories: data }

  return api
    .createReportingCategory(params)
    .then((response) =>
      dispatch(
        createReportingCategorySucceeded(response.data.itemCategories)
      )
    )
    .catch(() => dispatch(createReportingCategoryFailed()))
}

export const setCategoriesSortingMode = (payload) => ({
  type: SET_CATEGORIES_SORTING_MODE,
  payload,
})

export const setModifierGroupsSortingMode = (payload) => ({
  type: SET_MODIFIER_GROUPS_SORTING_MODE,
  payload,
})
